import React, { useEffect, useState } from "react";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";

interface GoalsOutstandingTableState {
  data: any;
}

export const GoalsOutstandingTable = ({ data }: GoalsOutstandingTableState): React.JSX.Element | null => {
  const [goalData, setGoalData] = useState<any[]>([]);

  const tableHeaders = [
    { label: "Case ID", key: "case_id", hide: true },
    { label: "Case", key: "case_name" },
    { label: "ID", key: "id", hide: true },
    { label: "Goal", key: "goal_name" },
    { label: "Name", key: "subject.name" },
    { label: "Created", key: "created_at_formatted" },
  ];

  useEffect(() => {
    if (data) {
      const { goals } = data;
      const outstanding = goals?.filter((g: any) => !g.completed_at);
      setGoalData(outstanding as any[]);
    }
  }, [data]);

  return goalData ? <DataTable tableHeadings={tableHeaders} tableData={goalData} title={"Goals Outstanding"} /> : loadingCard();
};
